function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgUdnr(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    fill: "#526075",
    fillRule: "evenodd",
    d: "M12.28 22.001l-.28.004c2.421-.001 4.411-3.95 4.645-9.004h5.31c-.492 4.964-4.614 8.861-9.675 9zm-.428 0l.148.004c-5.188 0-9.454-3.949-9.956-9.004h5.311c.23 4.952 2.143 8.842 4.497 9zM12 20.004c-.979 0-2.43-2.956-2.642-7.004h5.284c-.211 4.048-1.663 7.004-2.642 7.004zm0-18.01c5.188 0 9.454 3.95 9.956 9.005h-5.311C16.41 5.948 14.42 2 12 2c-2.42 0-4.41 3.947-4.645 9h-5.31c.5-5.056 4.767-9.005 9.955-9.005zm0 2.006c.978 0 2.43 2.953 2.642 7H9.358C9.57 6.953 11.022 4 12 4z"
  }));
}

SvgUdnr.clsName = 'icon-www__udnr';
SvgUdnr.remarkName = 'unknown';
export default SvgUdnr;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/Udnr.js
// module id = 2465
// module chunks = 17 18